import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import keyHeaders from './keyHeaders'

interface IGetRegistrationCodeValidityResponseBody {
  isValid: boolean
}

export interface IGetRegistrationCodeValidityResponse extends AxiosResponse {
  data: IGetRegistrationCodeValidityResponseBody
}

export function getRegistrationCodeValidity(code: string): Promise<IGetRegistrationCodeValidityResponse> {
  const url = `/study/reviewer/registration-codes/${code}`;
  return Client.get(url, { ...keyHeaders(), validateStatus: () => true });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/getRegistrationCodeValidity.ts